// extracted by mini-css-extract-plugin
export default {"reportType":"index_reportType__3Hu9H"};